import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

/* BrandImage */
const BrandImageSchema_ = z.object({
  _id: zExt.objectId(),
  url: z.string(),
  altText: z.string().optional(),
});

export const BrandImageSchema: z.ZodType<BrandImage> = BrandImageSchema_;
export interface BrandImage extends z.infer<typeof BrandImageSchema_> {}

const BrandImageUpsertSchema_ = BrandImageSchema_.extend({
  _id: zExt.objectId().optional(),
});

export const BrandImageUpsertSchema: z.ZodType<BrandImageUpsert> =
  BrandImageUpsertSchema_;
export interface BrandImageUpsert
  extends z.infer<typeof BrandImageUpsertSchema_> {}

const BrandImageCreateSchema_ = z.object({
  url: z.string(),
  altText: z.string().optional(),
});

export const BrandImageCreateSchema: z.ZodType<BrandImageCreate> =
  BrandImageCreateSchema_;
export interface BrandImageCreate
  extends z.infer<typeof BrandImageCreateSchema_> {}

/* Brand */
const BrandSchema_ = z.object({
  _id: zExt.objectId(),
  name: z.string().min(1).max(100),
  category: z.string().min(1).max(100),
  images: z.array(BrandImageSchema),
  team: zExt.objectId().nullish(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const BrandSchema: z.ZodType<Brand> = BrandSchema_;
export interface Brand extends z.infer<typeof BrandSchema_> {}

const CreateBrandSchema_ = z.object({
  name: z.string().min(1).max(100),
  category: z.string().min(1).max(100),
  images: z.array(BrandImageCreateSchema).optional(),
  team: zExt.objectId().nullish(),
});

export const CreateBrandSchema: z.ZodType<CreateBrand> = CreateBrandSchema_;
export interface CreateBrand extends z.infer<typeof CreateBrandSchema_> {}

const UpdateBrandSchema_ = BrandSchema_.omit({
  createdAt: true,
  updatedAt: true,
}).extend({ images: z.array(BrandImageUpsertSchema).optional() });

export const UpdateBrandSchema: z.ZodType<UpdateBrand> = UpdateBrandSchema_;
export interface UpdateBrand extends z.infer<typeof UpdateBrandSchema_> {}
